export default function GoogleMaps() {
    return (
        <div className="container-maps">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d247.39032640082718!2d-35.90732935094396!3d-7.212843031395502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ac1e2cd853f7f5%3A0x5cf752b65a44fb53!2sUnidade%20Acad%C3%AAmica%20de%20Sistemas%20e%20Computacao%20(UASC%20-%20UFCG)!5e0!3m2!1spt-BR!2sbr!4v1752690856706!5m2!1spt-BR!2sbr" 
                    width="100%" 
                    height="100%" 
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"
                    title="Mapa da localização da UFCG"
                    />
        </div>
    );
};